const ListIcon = ({ color, className, onClick }: {color?: string, className?: string, onClick?: () => void}) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    viewBox="0 0 40 40"
    onClick={onClick}
  >
    <circle cx="12" cy="15" r="1.6" fill={color || "#888"} />
    <rect x="18" y="14.5" width="14" height="2" rx="1" fill={color || "#888"} />
    <circle cx="12" cy="21" r="1.6" fill={color || "#888"} />
    <rect x="18" y="20.5" width="14" height="2" rx="1" fill={color || "#888"} />
    <circle cx="12" cy="27" r="1.6" fill={color || "#888"} />
    <rect x="18" y="26.5" width="14" height="2" rx="1" fill={color || "#888"} />
  </svg>
);

export default ListIcon;
